<template>
  <el-dialog
    top="10vh"
    class="edit-dialog"
    :title="row.id ? '编辑' : '新建'"
    :visible.sync="dialogVisible"
    :before-close="notBtn"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="600px"
  >
    <el-form ref="form" :model="form" :rules="rules" size="small" label-width="180px">
      <el-form-item label="版本名称：" prop="name">
        <el-input v-model.trim="form.name" placeholder="版本名称"></el-input>
      </el-form-item>
      <el-form-item label="版本号：" prop="code">
        <el-input v-model.trim="form.code" placeholder="版本号"></el-input>
      </el-form-item>
      <el-form-item label="APP类型：" prop="type">
        <Select style="width: 240px;" placeholder="APP类型" v-model="form.type" :options="typeList">
        </Select>
      </el-form-item>
      <el-form-item label="版本文件：" required>
        <el-upload
          ref="upload"
          action=""
          :multiple="false"
          :auto-upload="false"
          :limit="1"
          accept=".apk"
          :file-list="form.fileList"
          :on-change="upload"
          :on-exceed="explainFile"
          :on-remove="delFile"
        >
          <el-button slot="trigger" size="small" type="primary">上传文件</el-button>
        </el-upload>
      </el-form-item>
      <el-form-item label="版本说明：">
        <el-input
          type="textarea"
          resize="none"
          :autosize="{ minRows: 2, maxRows: 4 }"
          placeholder="版本说明"
          v-model.trim="form.remark"
        />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="notBtn">取 消</el-button>
      <el-button type="primary" @click="okBtn">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import Select from '@manage/components/CommonForm/Select'
export default {
  name: 'Dialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    row: {
      type: Object
    }
  },
  components: {
    Select
  },
  data() {
    return {
      dialogVisible: this.visible,
      typeList: [],
      form: {
        id: '',
        name: '',
        code: '',
        type: '',
        remark: '',
        fileId: '',
        fileList: []
      },
      rules: {
        name: [
          {
            required: true,
            message: '请填写版本名称',
            trigger: ['blur', 'change']
          }
        ],
        code: [
          {
            required: true,
            message: '请填写版本号',
            trigger: ['blur', 'change']
          }
        ],
        type: [
          {
            required: true,
            message: '请选择APP类型',
            trigger: 'change'
          }
        ]
      },
      addApi: this.$api.system.appVersion_add,
      updateApi: this.$api.system.appVersion_update
    }
  },
  mounted() {
    if (this.row.id) {
      this.queryDetail(this.row)
    }
    this.typeList = [
      {
        code: '01',
        name: '厨房冷柜'
      },
      {
        code: '02',
        name: '红酒柜'
      }
    ]
  },
  methods: {
    queryDetail(row) {
      this.form = JSON.parse(JSON.stringify(row))
      this.form.fileList = []
      this.form.fileList.push({
        name: this.form.fileId + '.apk',
        url: ''
      })
    },
    upload(file, fileList) {
      let formData = new FormData()
      formData.append('file', file.raw)
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      this.$ajax.post(this.$api.common.file_upload, formData, config).then((res) => {
        this.form.fileId = res.data
      })
    },
    explainFile(file, fileList) {
      this.$message({
        message: '已有APP版本文件，请先删除现有APP版本文件',
        type: 'warning'
      })
    },
    delFile(file, fileList) {
      this.form.file = ''
      this.form.fileList = []
    },
    notBtn() {
      this.$emit('update:visible', false)
    },
    okBtn() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (!this.form.fileId) {
            this.$message.error('请上传版本文件')
            return false
          }
          let params = {
            id: this.form.id,
            name: this.form.name,
            code: this.form.code,
            type: this.form.type,
            fileId: this.form.fileId,
            remark: this.form.remark
          }

          let api = this.row.id ? this.updateApi : this.addApi
          this.$ajax.post(api, params).then(() => {
            this.$message.success(`${this.row.id ? '修改成功' : '新建成功'}`)
            this.notBtn()
            this.$emit('refresh')
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.edit-dialog {
  .el-form-item__content {
    div {
      width: 240px;
    }
  }
}
</style>
